import { isMobile } from '../common/_constants'

export const toggleEditionClass = () => {
    const editionsContainer = document.querySelector('#editionsContainer')
    isMobile()
        ? (editionsContainer.className = 'editions-mobile')
        : (editionsContainer.className = 'tsn-account-menu-wrapper')
}
